module.exports = __webpack_public_path__ + "img/belgium-ischemic-heart-disease-female.22fc9298.png";